import logo from "../../assets/images/logo/logo.webp"
import "../../css/utils/spinner.css";

export default function Spinner() {
    return (
        <div className="spin-cont">
            <div className="spin-box">
                <span className="spinner" />
                <img src={logo} alt="" />
            </div>
        </div>
    );
}
